// ====================================================================================
// Main Entry Point - Prioritized Module Loading
// ====================================================================================
import { domReady, waitForIdle } from "./functions/utility.js";

// =========================================================================
// CRITICAL: Cache selectors + load immediately (blocking)
// =========================================================================
const contrastTrigger = document.querySelector(".btn--contrast");
const hasCCM = document.querySelector("[data-ccm-loader-group]");

const criticalImports = [];

if (contrastTrigger) {
  criticalImports.push(import("./modules/eyeAble.mjs").then((m) => m.init()));
}
if (hasCCM) {
  criticalImports.push(import("./modules/ccm19.mjs").then((m) => m.init()));
}

if (criticalImports.length) Promise.all(criticalImports).catch(console.error);

// =========================================================================
// HIGH PRIORITY: Load after DOM ready
// =========================================================================
domReady().then(() => {
  // Cache selectors
  const searchDialog =
    document.querySelector("#search-modal-dialog") ||
    document.querySelector(".header-search-modal") ||
    document.querySelector('[data-js="header-search"]');
  const burger =
    document.querySelector("#burger-modal-dialog") ||
    document.querySelector(".burger-menu-modal") ||
    document.querySelector('[data-js="burger-menu"]');
  const languageSelect = document.querySelector(".language-select-trigger");
  const submenuTrigger = document.querySelector(".open-submenu-button");
  const accordionTrigger =
    document.querySelector(".burger-menu__link-button") ||
    document.querySelector("[data-js='as-accordion-details-item']");
  const defaultAccordionTrigger = document.querySelector(
    "[data-js='accordion-item']",
  );
  const mainMenu = document.querySelector(".main-menu--primary");

  const imports = [];

  if (searchDialog) {
    imports.push(
      import("./modules/dialogHandler.mjs").then((m) =>
        m.init(
          "#search-modal-dialog",
          ".header-search-modal",
          '[data-js="header-search"]',
          '[data-js="header-search-modal-close"]',
          '[name="tx_solr[q]"]',
        ),
      ),
    );
  }

  if (burger) {
    imports.push(
      import("./modules/dialogHandler.mjs").then((m) =>
        m.init(
          "#burger-modal-dialog",
          ".burger-menu-modal",
          ".btn--burger-2",
          '[data-js="burger-menu-modal-close"]',
        ),
      ),
    );
  }

  if (mainMenu) {
    imports.push(import("./modules/mainMenu.mjs").then((m) => m.init()));
  }

  if (languageSelect) {
    imports.push(import("./modules/languageSelect.mjs").then((m) => m.init()));
  }

  if (submenuTrigger) {
    imports.push(
      import("./modules/submenu.mjs").then((m) =>
        m.init(".open-submenu-button"),
      ),
    );
  }

  if (accordionTrigger) {
    imports.push(import("./modules/accordion.mjs").then((m) => m.init()));
  }

  if (defaultAccordionTrigger) {
    imports.push(
      import("./modules/defaultAccordion.mjs").then((m) => m.init()),
    );
  }

  if (imports.length) Promise.all(imports).catch(console.error);
});

// =========================================================================
// LOW PRIORITY: Load when browser is idle
// =========================================================================
waitForIdle().then(() => {
  // Cache selectors
  const swiper = document.querySelector(".swiper-container");
  const certificateSwiper = document.querySelector(
    ".certificate-swiper-container",
  );
  const homeSwiper = document.querySelector(".home-swiper-container");
  const imageSwiper = document.querySelector(".image-swiper-container");
  const popoverSelect = document.querySelector(
    '[data-component*="popover-select-trigger"]',
  );
  const doctorFinder = document.querySelector(
    ".doctor-finder.tx-as-address-search",
  );
  const bodyCompass = document.querySelector(".ctype-ce_body_compass");
  const eventList = document.querySelector(".tx-sf-event-mgt");
  const eventSearchForm = document.getElementById("searchDemand");

  const imports = [];

  if (swiper) {
    imports.push(import("./modules/swiper.mjs").then((m) => m.init()));
  }

  if (certificateSwiper) {
    imports.push(
      import("./modules/certificateSwiper.mjs").then((m) => m.init()),
    );
  }

  if (homeSwiper) {
    imports.push(import("./modules/homeSwiper.mjs").then((m) => m.init()));
  }

  if (imageSwiper) {
    imports.push(import("./modules/imageSwiper.mjs").then((m) => m.init()));
  }

  if (popoverSelect) {
    imports.push(import("./modules/popoverSelect.mjs").then((m) => m.init()));
  }

  if (doctorFinder) {
    imports.push(import("./modules/asAddressSearch.mjs").then((m) => m.init()));
  }

  if (bodyCompass) {
    imports.push(import("./modules/asBodyCompass.mjs").then((m) => m.init()));
  }

  if (eventList) {
    imports.push(
      import("./modules/eventCardClickHandler.mjs").then((m) => m.init()),
    );
  }

  if (eventSearchForm) {
    imports.push(import("./modules/sfEventMgt.mjs").then((m) => m.init()));
  }

  if (imports.length) Promise.all(imports).catch(console.error);
});
